import {getDoc} from "@/libs/firestore";

export function getPNLValueOnce(projectId: string, modelId: string) {
    return getDoc(`projects/${projectId}/models/${modelId}/PNL/PNLValue`);
}